import { render, staticRenderFns } from "./TabelaSancoesRestricoesPj.vue?vue&type=template&id=ffdf5a8c&lang=pug"
import script from "./TabelaSancoesRestricoesPj.vue?vue&type=script&lang=js"
export * from "./TabelaSancoesRestricoesPj.vue?vue&type=script&lang=js"
import style0 from "./TabelaSancoesRestricoesPj.vue?vue&type=style&index=0&id=ffdf5a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports